var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquareSlidersVertical = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "square-sliders-vertical",
    d: "M13.714,33.143a1.142,1.142,0,0,1,1.143,1.143V45.714a1.142,1.142,0,0,1-1.143,1.143H2.286a1.142,1.142,0,0,1-1.143-1.143V34.286a1.142,1.142,0,0,1,1.143-1.143ZM2.286,32A2.288,2.288,0,0,0,0,34.286V45.714A2.288,2.288,0,0,0,2.286,48H13.714A2.288,2.288,0,0,0,16,45.714V34.286A2.288,2.288,0,0,0,13.714,32Zm2.857,3.429A.573.573,0,0,0,4.571,36v1.714H3.714a.571.571,0,1,0,0,1.143H6.571a.571.571,0,1,0,0-1.143H5.714V36A.573.573,0,0,0,5.143,35.429Zm0,4.571a.573.573,0,0,0-.571.571V44a.571.571,0,1,0,1.143,0V40.571A.573.573,0,0,0,5.143,40Zm5.714-4.571a.573.573,0,0,0-.571.571v4H9.429a.571.571,0,1,0,0,1.143h2.857a.571.571,0,1,0,0-1.143h-.857V36A.573.573,0,0,0,10.857,35.429Zm0,6.857a.573.573,0,0,0-.571.571V44a.571.571,0,1,0,1.143,0V42.857A.573.573,0,0,0,10.857,42.286Z",
    transform: "translate(0 -32)",
    fill: "#1a1a1a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquareSlidersVertical);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/square-sliders-vertical.8d76bef2b045d7bb82494dc8b9a4b380.svg";